import { GridFilterOperator, GridFilterItem } from "@mui/x-data-grid";

const NumberBetweenOperator: GridFilterOperator<any, number>[] = [
  {
    label: "Between",
    value: "between",
    getApplyFilterFn: (
      filterItem: GridFilterItem
    ): ((value: number | null) => boolean) | null => {
      if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
        return null;
      }

      return (value: number | null): boolean => {
        // if one of the sides is null, then we use it as an unbounded range
        if (filterItem.value[0] === null) {
          return value !== null && value <= filterItem.value[1];
        } else if (filterItem.value[1] === null) {
          return value !== null && filterItem.value[0] <= value;
        }

        return (
          value !== null &&
          filterItem.value[0] <= value &&
          value <= filterItem.value[1]
        );
      };
    },
  },
];

export default NumberBetweenOperator;
